import React from 'react';
import connect from '@active/react-utils/hoc/connect';

const CommonPropsContext = React.createContext({});
const CommonPropsConsumer = CommonPropsContext.Consumer;

export const CommonPropsProvider = CommonPropsContext.Provider;

export const connectCommonProps = connect(CommonPropsConsumer);
